'use strict';
module.exports = {
	Identifier: 'EquipmentWorkspace', Ordinal: 247,
	Entity: { Name: 'Equipment', IDField: 'IDEquipment', Collection: 'Equipments', GUIDField: 'GUIDEquipment' },
	Header: { Eyebrow: 'Equipment', Title: (r) => r.Name || `Equipment ${r.IDEquipment}`,
		Actions: [ { Label: 'Edit', Icon: 'fas fa-pen', Style: 'is-link', OnClick: 'goToEdit()' } ], ListRoute: '#/PSRS/Equipment/List' },
	Tabs: [
		{ Key: 'overview', Label: 'Overview', Icon: 'fas fa-circle-info', Content: { kind: 'overview' } },
		{ Key: 'organizations', Label: 'Organizations', Icon: 'fas fa-building', Content: { kind: 'assoc', ref: 'EquipmentOrganization' } },
	],
	FieldGroups: [ { Name: 'Identity', Fields: [ { Key: 'Name', Label: 'Name', Wide: true }, { Key: 'Code', Label: 'Code', Mono: true }, { Key: 'Description', Label: 'Description', Wide: true }, { Key: 'Status', Label: 'Status' } ] } ],
};
